// extracted by mini-css-extract-plugin
module.exports =  {"link":"v6Z4Ka2bpVm7_NBEVHrw"};